/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Regex_LabelInputs */



/**
* | output |
* | --- |
* | "Regex" |
*
* @param {Find_Replace_Regex_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_regex_label = /** @type {((inputs?: Find_Replace_Regex_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Regex_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Regex")
	if (locale === "de") return /** @type {LocalizedString} */ ("Regex")
	if (locale === "it") return /** @type {LocalizedString} */ ("Espressione regolare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Регулярное выражение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Expresión regular")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正则表达式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("正規表現")
	if (locale === "hi") return /** @type {LocalizedString} */ ("regex")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Expressão regular")
	return /** @type {LocalizedString} */ ("Regex")
});